import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import * as R from 'ramda';
import SigninIlustration from '../../../assets/images/placeholder/Signin-ilustration.svg';
import * as Loadings from '../../../constants/loadings/auth';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateUser } from '../../../actions/auth-api';
import Credentials from '../../../constants/models/credentials';
import contriesList from 'iso-3166-1-alpha-2';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';

import { Cookies } from '../../_common/cookies';


export const PartnerSignin = () => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const loginFormRef = useRef(null);
    const auth = useSelector(state => state.auth);
    const [credentials, setCredentials] = useState({
        email: '',
        phoneNumber: '',
        password: '',
        countryCode: '33',
        phoneCountry: "FR"
    });
    const [loginWithEmail, setLoginWithEmail] = useState(true);

    const errors = { invalidCredentials: 'invalidCredentials' };
    const [displayError, setDisplayError] = useState(undefined);
    const [showPassword, setShowPassword] = useState(false);

    const returnUrl = new URLSearchParams(location.search).get("returnUrl");

    useEffect(() => {
        if (!R.isNil(auth.authError)) {
            switch (auth.authError) {
                case 'invalidCredentials':
                    setDisplayError(errors.invalidCredentials);
                    setCredentials({ ...credentials, password: '' });
                    loginFormRef.current.classList.remove('was-validated');
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.authError]);

    useEffect(() => {
        if (!R.isNil(auth.loggedIn) && auth.loggedIn === false) {

            history.push("/auth/partner/signin/code" + (!R.isNil(returnUrl) ? `?returnUrl=${returnUrl}` : ""));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.loggedIn]);

    function formSubmit(event) {
        event.preventDefault();
        if (loginFormRef.current.checkValidity() && !auth.isLoading.includes(Loadings.AUTH_USER)) {
            let creds = undefined;
            if (loginWithEmail) {
                creds = new Credentials({ email: credentials.email, password: credentials.password });
            }
            else {
                const internationalPhoneNumber = parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry);
                if (internationalPhoneNumber.isValid()) {
                    creds = new Credentials({ phoneNumber: internationalPhoneNumber.number, password: credentials.password });
                } else {
                    document.getElementById("phoneNumberInput").setCustomValidity("Le numéro de téléphone n'est pas valide.");
                    return;
                }
            }
            dispatch(authenticateUser(creds));
        }
        loginFormRef.current.classList.add('was-validated');
    }
    return (
        <main role="main" className="view flex-grow-1 pb-sm pb-xl-gutter" style={{ minHeight: "500px" }}>
            <div className="container-fluid container-modal m-auto h-inherit">
                <section className="card card-body card-lg rounded-top-left-xl rounded-bottom-right-xl h-inherit">
                    <h4 className="sr-only visually-hidden">Registration de Compte</h4>
                    <div className="row justify-content-row gx-2 h-inherit">
                        <div className="col-12 col-lg h-inherit">
                            <img className="img-fluid img-contain container-md-wide mx-auto mt-4 my-lg-auto h-inherit" width="480" src={SigninIlustration} alt="Assist@" />
                        </div>
                        <div className="col order-first order-lg-last h-inherit">
                            <nav className="nav text-right mb-auto">
                                <h1 className="sr-only visually-hidden">Register</h1>
                                {/* <span className="small font-weight-bold ml-auto">Je n'ai pas de compte ? <Link className="text-primary" to="/auth/signup">S'inscrire</Link></span> */}
                            </nav>
                            <form className="container-xl-base py-2 mb-auto" noValidate ref={loginFormRef} onSubmit={(event) => { formSubmit(event); }}>
                                <h1 className="h1 text-primary font-weight-bolder mb-6">Accès espace partenaires</h1>
                                <div className="form-group">
                                    <div className="flex-row align-items-center">
                                        <label className="h6 font-weight-bolder mr-4 w-75" htmlFor="username">Saisissez votre {loginWithEmail ? 'email' : 'numéro de portable'}</label>
                                    </div>
                                    {
                                        loginWithEmail === false ?
                                            <div className="input-group mb-0">
                                                <select className="custom-select rounded container-tiny mr-2" id="naturalite" tabIndex={-98} value={credentials.countryCode} onChange={(event) => {
                                                    let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
                                                    setCredentials({ ...credentials, countryCode: event.target.value, phoneCountry: pc });
                                                }}>
                                                    {
                                                        countryTelData.allCountries.map((country, index) => {
                                                            let dialCode = country.dialCode;
                                                            return (
                                                                <option key={index} value={dialCode}>{countries.getName(country.iso2, "fr", { select: "official" })} (+{dialCode})</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                                <input type="tel" required id="phoneNumberInput" className="form-control rounded" value={credentials.phoneNumber} placeholder="00 00 00 00 00"

                                                    value={parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry) !== undefined ? parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry).formatNational() : credentials.phoneNumber}
                                                    onChange={(e) => {
                                                        document.getElementById("phoneNumberInput").setCustomValidity("");
                                                        setCredentials({ ...credentials, phoneNumber: e.target.value });
                                                    }}
                                                    onBlur={() => {
                                                        setCredentials({ ...credentials, phoneNumber: credentials.phoneNumber.trim() });
                                                    }} />
                                            </div>
                                            :
                                            <input type="email" required className="form-control" id="username" defaultValue={credentials.username} placeholder="votreemail@mail.fr" onInput={(event) => {
                                                event.preventDefault();
                                                setCredentials({ ...credentials, email: event.target.value });
                                                setDisplayError(undefined);
                                            }} onBlur={() => {
                                                setCredentials({ ...credentials, email: credentials.email.replace(/\s/g, '').trim() });;
                                            }} />
                                    }

                                    <div className="invalid-feedback">Champs obligatoire</div>
                                </div>
                                <div className="form-group">
                                    <div className="flex-row align-items-center">
                                        <label className="h6 font-weight-bolder" htmlFor="setpassword">Mot de passe</label>
                                        <Link to="/auth/password/" className="p-0 mb-auto ml-auto text-primary small font-weight-bold lh-headings text-right">Mot de passe oublié ?</Link>
                                    </div>
                                    <div className="input-group">
                                        <input type={showPassword === false ? "password" : ''} required className="form-control" id="setpassword" placeholder="mot de passe" value={credentials.password} onChange={(event) => {
                                            event.preventDefault();
                                            setCredentials({ ...credentials, password: event.target.value });
                                            setDisplayError(undefined);
                                        }} />
                                        <div className="input-group-prepend">
                                            <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                                <i className={"eva o-30 fs-root lh-0 " + (showPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showPassword" onClick={() => { setShowPassword(!showPassword); }}></i>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Champs obligatoire</div>
                                    </div>
                                </div>
                                <div className={"invalid-feedback text-inherit mb-4 mt-n1" + (!R.isNil(displayError) ? ' d-block' : '')}>
                                    <i className="eva eva-alert-triangle-outline text-danger fs-sm align-middle"></i><span className="o-80 align-middle ml-1">Identifiants incorrects</span>
                                </div>
                                <div role="button" className="p-0 mb-4 small lh-headings text-muted" onClick={
                                    () => { setLoginWithEmail(!loginWithEmail); }
                                }>
                                    Se connecter avec son
                                    <Link to={"/auth/partner/signin" + (!R.isNil(returnUrl) ? `?returnUrl=${returnUrl}` : "")} className="text-primary mx-1 font-weight-bold">{loginWithEmail ? 'numéro de portable' : 'adresse email'}</Link>
                                    ?
                                </div>
                                <input type="submit" hidden={true} />
                            </form>
                            <footer className="block mt-auto text-left w-100 rounded-inherit">
                                <Link to="/index" className="btn btn-faded px-md-gutter mr-3">Fermer</Link>
                                {/* <Link ref={nextPageRef} to="/auth/identity/init" className={"btn btn-info px-md-gutter px-4" + (user.isLoading.includes(Loadings.AUTH_USER) ? ' disable': '')}>Se connecter</Link> */}
                                <button className={"btn btn-info px-md-gutter px-4 loading-btn" + (auth.isLoading.includes(Loadings.AUTH_USER) ? ' show' : '')} disabled={auth.isLoading.includes(Loadings.AUTH_USER)}
                                    onClick={(event) => { formSubmit(event); }}>Se connecter
                                    <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                                </button>
                            </footer>
                        </div>
                    </div>
                </section>
            </div>
            <Cookies />
        </main>
    );
};